import PropTypes from 'prop-types';
import React from 'react';

export default function ShippingDate({
  numParts = undefined,
  shipDateTarget,
  shipDateActual = undefined,
  shipDateBusinessDays,
  isInternal = false,
}) {
  const hasShipped = shipDateActual !== undefined
    && shipDateActual !== 'null'
    && shipDateActual !== null;
  return (
    <p className="shippingDate">
      {hasShipped ? 'Shipped ' : 'Ships '}
      {numParts !== undefined
        ? `${numParts} ${numParts === 1 ? 'part' : 'parts'} on `
        : ''}
      <span className="date">
        {hasShipped ? shipDateActual : shipDateTarget}
      </span>
      {shipDateBusinessDays >= 0 && (
        <span className={`
          businessDays
          ${shipDateBusinessDays === 0 ? ' today' : ''}`}
        >
          {shipDateBusinessDays === 0
            ? 'today'
            : `${shipDateBusinessDays} B/D`}
        </span>
      )}
      {!hasShipped && shipDateBusinessDays === -1 && !isInternal && (
        <span className="businessDays late">LATE</span>
      )}
    </p>
  );
}

ShippingDate.propTypes = {
  numParts: PropTypes.number,
  shipDateTarget: PropTypes.string.isRequired,
  shipDateActual: PropTypes.string,
  shipDateBusinessDays: PropTypes.number.isRequired,
  isInternal: PropTypes.bool,
};
